import { useEffect, useRef, useState } from "react";
import { ReactComponent as IconAlarm } from "../../../styles/assets/svg/icon_alarm.svg";
import { ReactComponent as IconMenu } from "../../../styles/assets/svg/icon_sidemenu.svg";
import { ReactComponent as IconUser } from "../../../styles/assets/svg/icon_user.svg";
import { Buttons } from "../../atoms/Buttons";
import { ChangePasswordModal } from "../../containers/Member/ChangePasswordModal";
import { HeaderPopup } from "../../molecules/HeaderPopup";
import * as S from "./Header.style";
import { Legend } from "../../molecules/Legends";
import { ModalAlarm } from "../../molecules/Modals/ModalAlarm";
import { useRecoilValue } from "recoil";
import { currentShipState } from "../../../common/states/ship";
import { useQuery } from "@tanstack/react-query";
import { request } from "../../../common/api";
import { readAccessToken } from "../../../common/functions/authFunctions";
import dayjs from "dayjs";

interface HeaderProps {
  asideToggle?: any;
  asideOpen?: boolean;
}

export const Header = ({ asideOpen, asideToggle }: HeaderProps) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [popupShow, setPopupShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [modalAlarmShow, setModalAlarmShow] = useState(false);
  const shipInfo = useRecoilValue(currentShipState);

  const [isRefresh, setIsRefresh] = useState<boolean>(true);

  const popupOutsideClick = (e: any) => {
    if (popupRef.current === e.target) {
      setPopupShow(false);
    }
  };

  const resizeListener = () => {
    setInnerWidth(window.innerWidth);
  };

  // 상태진단 실행시간 GET
  const { data: statusTime } = useQuery({
    queryKey: ["GET_STATUS_TIME", isRefresh],
    queryFn: async () => {
      const result = await request<string | null>({
        method: "GET",
        url: "/state-alarm/real-time",
        params: { shipName: shipInfo.shipName },
      });

      if (result) {
        return dayjs(result).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    enabled: !!readAccessToken(),
  });

  // 상태 진단 갯수 GET
  const { data: statusListCount } = useQuery({
    queryKey: ["GET_STATUS_LIST_COUNT", isRefresh],
    queryFn: async () => {
      return await request<any>({
        method: "GET",
        url: "/state-alarm/count",
        params: {
          steShiptypeName: shipInfo.shipTypeNo,
          steShipName: shipInfo.shipNo,
        },
      });
    },
    enabled: !!readAccessToken(),
  });

  // Update Time GET
  const { data: updateTime } = useQuery({
    queryKey: ["GET_UPDATE_TIME"],
    queryFn: async () => {
      setIsRefresh(false);

      const result = await request<string | null>({
        method: "GET",
        url: "/state-alarm/update-time",
        params: { shipId: shipInfo.shipTypeId },
      });

      if (result) {
        return dayjs(result).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    enabled: !!readAccessToken(),
  });

  useEffect(() => {
    setIsRefresh(false);
  }, [isRefresh]);

  useEffect(() => {
    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return (
    <>
      <S.HeaderSection>
        <S.ShipModelTit>
          {asideOpen === true ? (
            ""
          ) : innerWidth < 1400 ? (
            <S.HeaderSidemenuBtn type="button" onClick={asideToggle}>
              <IconMenu />
            </S.HeaderSidemenuBtn>
          ) : (
            ""
          )}
          {shipInfo.shipTypeName} / {shipInfo.shipName}
        </S.ShipModelTit>
        <S.HeaderBtnBox>
          <div
            style={{
              display: "flex",
              marginRight: "10px",
              flexDirection: "column",
              alignItems: "end",
              gap: "6px",
            }}
          >
            <Legend title="상태진단 실행시간" type="uptime">
              <>{statusTime}</>
            </Legend>
            <Legend title="Update time" type="uptime">
              <>{updateTime}</>
            </Legend>
          </div>

          {/* <Buttons type="button" size="md" layout="icon" icon={<IconAlarm />} /> */}
          <Buttons
            type="button"
            size="md"
            layout="icon"
            icon={
              statusListCount === 0 ? (
                <IconAlarm />
              ) : (
                <div style={{ position: "relative" }}>
                  <IconAlarm />
                  <div
                    style={{
                      position: "absolute",
                      top: "-2px",
                      right: "-8px",
                      padding: "2px",
                      borderRadius: "10px",
                      background: "red",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        color: "white",
                      }}
                    >
                      {statusListCount >= 99 ? "99+" : statusListCount}
                    </p>
                  </div>
                </div>
              )
            }
            onClick={() => setModalAlarmShow(!modalAlarmShow)}
          />
          <Buttons
            type="button"
            size="md"
            layout="icon"
            icon={<IconUser />}
            onClick={() => {
              setPopupShow(!popupShow);
            }}
          />
        </S.HeaderBtnBox>
      </S.HeaderSection>
      {popupShow && (
        <HeaderPopup
          popupRef={popupRef}
          popupOutsideClick={popupOutsideClick}
          handleModal={() => {
            setPopupShow(false);
            setModalShow(!modalShow);
          }}
        />
      )}
      {modalShow && (
        <ChangePasswordModal formId="change_pw" setModalShow={setModalShow} />
      )}
      {modalAlarmShow && (
        <ModalAlarm setModalShow={setModalAlarmShow} statusTime={statusTime} />
      )}
    </>
  );
};
